export default __webpack_public_path__ + "static/media/sdmobile-tablet2.06559b90.svg";